<template>
  <div style="margin-bottom:300px;">
  
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->



  <div  v-if="editMc && taskExist" class="text-center"  style="margin-top:30px;margin-bottom:50px;max-width:300px;margin-left:auto;margin-right:auto;">
     <p-button type="default"  block round  @click.prevent="goToTask">View Task & Resolution</p-button> 
    </div>
  
  	
  	<div v-if="isCompany==false">
     <h4  slot="header" class="title">
    	 Member Information
     </h4>  
	<card v-if="personFound" class="form-horizontal" style="padding:30px 0px 30px 30px;">
	 <span style="font-weight:bold;"> {{model.first_name}}  {{model.last_name}} ({{model.gov_id}}) -  {{model.address_1}}</span>
	</card>
	</div>
	
	
	<div v-if="isCompany==true">
		
			<h4  slot="header" class="title">
				 Member Information
			 </h4>  
			<card class="form-horizontal" style="padding:30px 0px 30px 30px;">
			 <span style="font-weight:bold;"> {{company.company_name}} ({{company.company_reg_num}}) -  {{company.address}}</span>
			</card>
			<br/>
			
		  <h4  slot="header" class="title">
			 Member's Representative Information
		 </h4>  
		<card v-if="personFound" class="form-horizontal" style="padding:30px 0px 30px 30px;">
		 <span style="font-weight:bold;"> {{model.first_name}}  {{model.last_name}} ({{model.gov_id}}) -  {{model.address_1}}</span>
		</card>
	
		
	</div>




      
 <card  v-if="createForm" class="form-horizontal">
    <h4 slot="header" class="card-title">
      Add A New Person To The Database
    </h4>

    

    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">First Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="first_name"
                  v-validate="modelValidations.first_name"
                  :error="getError('first_name')"
                  v-model="model.first_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Last Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="last_name"
                  v-validate="modelValidations.last_name"
                  :error="getError('last_name')"
                  v-model="model.last_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Address</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="address_1"
                  v-validate="modelValidations.address_1"
                  :error="getError('address_1')"
                  v-model="model.address_1">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Nationality</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="nationality"
                  v-validate="modelValidations.nationality"
                  :error="getError('nationality')"
                  v-model="model.nationality">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">ID Number</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="gov_id"
                  v-validate="modelValidations.gov_id"
                  :error="getError('gov_id')"
                  v-model="model.gov_id">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Email</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="email"
                  v-validate="modelValidations.email"
                  :error="getError('email')"
                  v-model="model.email">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Contact Number</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="contact_num"
                  v-validate="modelValidations.contact_num"
                  :error="getError('contact_num')"
                  v-model="model.contact_num">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>


	

    
    <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.effective_date" type="date" placeholder="Select A Date"
                              v-validate="modelValidations.effective_date" >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
	
	
	


  

  </card>
  
  
   <div style="margin-top:100px;">
  		 <h4 v-if="editMc"  slot="header" class="title">
	    	Change: Member Details
		</h4>
		<h4 v-else  slot="header" class="title">
		   Change: Member Details
		</h4>
   </div>
   
   
  <card  v-if="createChangeForm" class="form-horizontal">
   
    
     <div class="row">
      <label class="col-sm-2 col-form-label">New Member Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="mc.status"
                             :disabled="mc.change_status==4"
                             >
                    <el-option v-for="option in selects.officer_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    
	<!-- <div class="row">
      <label class="col-sm-2 col-form-label">Is Officer Point-Of-Contact</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="oc.is_contact_person">
                    <el-option v-for="option in selects.is_contact"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>required</code>
      </div>
    </div> -->

    
    <div class="row">
      <label class="col-sm-2 col-form-label">Effective Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="mc.effective_date" type="date" placeholder="Select A Date"
                              v-validate="modelValidations.effective_date" >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
	

    
    
    <div v-if="0" class="row">
      <label class="col-sm-2 col-form-label">Filing Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="mc.filing_date" type="date" placeholder="Select A Date"
                               >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Notes</label>
      <div class="col-sm-7">
       	   <textarea 
        		 cols="45" rows="10"
                  name="notes"
                  v-model="mc.notes">
       	 </textarea>
      </div>
      <div class="col-sm-3 label-on-right">
             	<span style="font-size:11px;"><i> * Add your notes, ACRA transaction code, etc.</i></span>

      </div>
    </div>
	
    

    


    
   
    
    
   
    
    
    
   
    
    <div v-if="false">
     <!--<div v-if="editOc && !taskExist" class="text-center"  style="margin-top:30px;margin-bottom:50px;">-->
      <p-button   type="default" @click.prevent="goToCreateTaskDetails">Create Resolution & New Task</p-button>
    </div>
    
  
    
</card>


	<div style="margin-top:100px;">
	<h4 class="title">Status</h4>
   </div>
   <card style="margin-bottom:100px;">
   
       <div v-if="editMc" class="row" style="">
      <label class="col-sm-2 col-form-label">Change: Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="mc.change_status">
                    <el-option v-for="option in selects.change_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
   
   
   </card>
   
   
 <!-- start register card-->
   <div style="margin-top:100px;">
	<h4 class="title">Company Registers</h4>
   </div>
   
   <card style="margin-bottom:100px;">
   
   	 <div class="row" >
      <label class="col-sm-2 col-form-label">Insert This Change Into Company's Registers</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder="Select Position"
                             v-model="mc.is_official"
                             >
                    <el-option v-for="option in selects.is_official"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
   </card>
   <!-- end register card-->
   


	<h4 style="font-weight:bold;">Actions</h4>	  
	<card>
	 	<div v-if="editMc" >
     		 <p-button   type="info" @click.prevent="validateUpdateMemberChange">Update Member Change</p-button>
   		 </div>

	</card>

  
    
        
     

  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	if(this.$route.params.type== "edit"){
     		this.showSearchBar = false;
     		
     		
     		
     		let uri = this.$base_url+'/api/v1/officers/viewmemberchange/'+ this.$route.params.mcid;
			 ApiService.get(uri).then(response => {
		
				this.mc = response.data.mc;
				this.mc.status = response.data.mc.new_member_status;
				this.mc.change_status = response.data.mc.change_status;
				
				
				let p = response.data.mc;
				if(p.member.person){
					this.model = p.member.person;
				}
				else{
					this.isCompany = true;
					this.model = p.member.shareholder_company.person;
					this.company = p.member.shareholder_company;
				}
				this.editMc = true;
				this.personFound = true;
				this.createChangeForm = true;
				
				if(this.mc.task_id){
					this.taskExist = true;
				}
				else{
					this.mc.task_id = 0;
				}
			
			})
     		
     	}
    	
     	if(this.$route.params.eid!=0){
     
			let uri = this.$base_url+'/api/v1/entities/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				//this.createForm = false
				//this.model = response.data.entity;
				this.coy = response.data.entity;
				
			
			})
      	}//get connected entity info
      	
      	
      
    },
    
     
    data () {
      return {
        coy:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	ocid: this.$route.params.ocid,
    	pid: 0,
    	createForm: false,
    	editMc: false,
    	company: [],
    	isCompany: false,
    	taskExist: false,
    	showSearchBar: true,
    	createChangeForm: false,
    	search_id_num: '',
    	personFound: false,
    	showTransferFrom: false,
    	oc_position: 1,
        model: {
          first_name: '',
          last_name: '',
          address_1: '',
          status: 1,
          is_contact_person: 2,
          effective_date: '',
          position: 2,
          nationality:'',
          gov_id:'',
          email:'',
          contact_num:'',
          eid: this.$route.params.eid

        },
        mc:{
        	status: 1,
        	position: 1,
          	is_contact_person: 2,
          	effective_date: '',
          	filing_date:'',
          	notes: '',
          	title:'',
          	change_status:1,
        },

        modelValidations: {
          first_name: {
            required: true
          },
          last_name: {
            required: true,
          },
          address_1: {
            required: true,
          },
        
          is_contact_person: {
            required: true,
          },
          effective_date: {
            required: true,
          },
  
          nationality: {
            required: true,
          },
          gov_id: {
            required: true,
          },
          email: {
            required: true,
            email: true
          },
          contact_num: {
            required: true,
          },
          
          
          
        },
        
        selects: {
          officer_status: [
            {value: 1, label: 'Appointed'},
            {value: 2, label: 'Resigned'},
		   ],
		   is_official:[
		   	 {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   
		   ],
		  change_status: [
            {value: 1, label: 'Pending'},
            {value: 4, label: 'Completed'},
            {value: 5, label: 'Cancelled'},
		   ],
		  is_contact:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ] ,
		   officer_position: [
            {value: 1, label: 'Director'},
            {value: 2, label: 'Nominee Director'},
            {value: 3, label: 'Secretary'},
            {value: 4, label: 'Director & Secretary'},
		   ],
        },
      }
    },
    methods:{
       deleteOc(){
       		const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'Any resolution or task connected to this change will also be deleted.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, delete it!',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/officers/delete_oc/'+ vm.$route.params.ocid;
          	 
     	  	 ApiService.get(uri).then(response => {
				swal({
				  title: 'Deleted!',
				  text: 'This Change: Officer has been deleted.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					 vm.$router.push( '/view-entity/'+vm.$route.params.eid);
				
				})
				//end swal
            })
         
            
          })
       }, //end delete oc
       goToTask(){
       		this.$router.push( '/edit-task/'+ this.mc.task_id + '/entity/'+ this.$route.params.eid)
       },
       goToCreateTaskDetails(){
       		
       		let task_name_sys = "oc";
       		       		
       
       		this.$router.push( '/create-task-details/'+ this.$route.params.eid+"/"+task_name_sys+"/"+this.$route.params.ocid +"/"+this.oc.task_id+"/"+this.oc.status)
       },
       onTransactionTypeChange(event){
       		if(this.shares.transaction_type == 3){
       			let uri = this.$base_url+'/api/v1/shareholders/entity/'+this.$route.params.eid;
       		
      			ApiService.get(uri).then(response => {
      				
      				this.selects.shareholders_list = response.data.shareholders;
      				this.showTransferFrom = true;
   
      				
      			});
       		
       		}else{
       			this.showTransferFrom = false;
       		}
       
       },
       searchPerson(){
       		let search_term = "NONE";
       		if(this.search_id_num){
       			search_term = this.search_id_num
       		}
       		let uri = this.$base_url+'/api/v1/shareholders/search/'+search_term;
       		
       		const vm = this;
      		ApiService.post(uri).then(response => {
      				if(response.data.exist == 1){
      				
      					this.model = response.data.person;
      					this.pid = response.data.person.id;
      					this.personFound = true;
      					this.createForm = false;
      					this.createChangeForm = true;
      				}
      				else{
      					swal({
						  title: 'Not Found',
						  text: 'This person has not been added yet.',
						  type: 'warning',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
			
							vm.createForm = true;
							vm.personFound = false;
							vm.createChangeForm = true;
				
						})
      				
      					
      				}
         		
     		 })
    	
    	},

       getError(fieldName) {
        return this.errors.first(fieldName)
      },
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    
	  validateUpdateMemberChange(){
	  	 this.mc.position = this.mc_position;
	  	 this.$validator.validateAll().then(isValid => {
	  	 	let uri = this.$base_url+'/api/v1/officers/update_mc';
       	      		
       		
       		const vm = this;
      		ApiService.post(uri, {
      			'eid': this.eid,
      			'mcid': this.$route.params.mcid,
      			'mc': this.mc
      		
      		}).then(response => {
      			vm.$router.push( '/edit-task/'+ response.data.mc.task_id + "/entity/" + response.data.mc.entity_id);
      		
      		})
	  	 
	  	 
	  	 });
	  },  
	    
	  validateOc(){
	  	  this.oc.position = this.oc_position;
	  	 this.$validator.validateAll().then(isValid => {
	  	 	let uri = this.$base_url+'/api/v1/officers/create_oc';
       	        		
       		const vm = this;
      		ApiService.post(uri, {
      			'pid': this.pid,
      			'eid': this.eid,
      			'oc': this.oc
      		
      		}).then(response => {
      		
      			vm.$router.push( '/view-entity/'+ vm.eid)
      		})
	  	 	
	  	 
	  	 });
	  },  
      validate() {
        this.$validator.validateAll().then(isValid => {
	  	 	let uri = this.$base_url+'/api/v1/officers/create_oc';
       	      		
       		
       		const vm = this;
      		ApiService.post(uri, {
      			'pid': this.pid,
      			'eid': this.eid,
      			'oc': this.oc,
      			'person': this.model
      		
      		}).then(response => {
      			vm.$router.push( '/view-entity/'+ vm.eid)
      		
      		})
	  	 
	  	 
	  	 });
      },///end validate+create
      
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


